
import DashboardLayout from '../pages/Dashboard/Layout/DashboardLayout'

const WorkPlan = () => import('../pages/WorkPlan/index')
const WeeklyExecution = () => import('../pages/WorkPlan/WeeklyExecution/Index')

const workPlanPages = {
  path: '/',
  component: DashboardLayout,
  name: 'WorkPlan',
  title: 'Plan de Trabajo',
  icon: 'build',
  excludedGroups: [ 'Extranet' ],
  excludedRoles: [ 'IDEAL' ],
  children: [
    {
      path: '/plan_trabajo/generar',
      name: 'Plan de Trabajo',
      title: 'Generar Plan de Trabajo',
      component: WorkPlan,
      meta: {
        ifUserCan: {
          add: 'WorkPlan/workplanreal',
        },
      },
    },
    {
      path: '/plan_trabajo/ejecucion_semanal',
      name: 'Ejecución Semanal',
      title: 'Ejecución Semanal',
      component: WeeklyExecution,
      props: {
        hideSidebar: true,
        reportMode: false,
      },
      meta: {
        ifUserCan: {
          view: 'WorkPlan/workplanreal',
        },
      },
    },
    {
      path: '/plan_trabajo/reporte_ejecucion',
      name: 'Reporte de Ejecución Semanal',
      title: 'Reporte de Ejecución Semanal',
      component: WeeklyExecution,
      props: {
        reportMode: true,
      },
      meta: {
        ifUserCan: {
          view: 'WorkPlan/workplanreal',
        },
      },
    },
  ],
}

export default workPlanPages



// WEBPACK FOOTER //
// ./src/router/workplanRoutes.js